/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {ProgramAutoCompleteFieldEditor} from "../ServiceDrivenEditors";

/**
 * Program picker built on ProgramAutoCompleteFieldEditor, parameterized by the
 * hierarchy level it searches. `parentId` is the search param consumed by
 * ProgramController::GetAll:
 *
 *   'null'      → root (top-level) programs only
 *   'not-null'  → subprograms only
 *   undefined   → both root programs and subprograms
 *
 * The search is scoped to the editing record's organization (CustomData /
 * RootData); callers can override any param via additionalSearchParams.
 */
const _ProgramFieldEditor = (props, parentId) => {
	const orgId = props?.CustomData?.organizationId || props.RootData?.organizationId;

	return <ProgramAutoCompleteFieldEditor
		{...props}
		// A root-only picker can only ever hold a top-level program, so the "Program"
		// subtext under the control says nothing the field's own label does not. The
		// read-only viewer suppresses it for the same value, and this keeps the two
		// modes of Program's Parent Program field showing the same thing.
		showSubtitle={parentId !== 'null'}
		additionalSearchParams={{
			orgId,
			...(parentId === undefined ? {} : {parentId}),
			...(props?.additionalSearchParams ?? {}),
		}}
	/>;
};

export function ProgramFieldEditor(parentId) {
	const component = (props) => _ProgramFieldEditor(props, parentId);
	component.displayName = `ProgramFieldEditor(${parentId === undefined ? 'any' : parentId})`;
	return component;
}

export const RootProgramFieldEditor = ProgramFieldEditor('null');
export const SubProgramFieldEditor = ProgramFieldEditor('not-null');
export const ProgramOrSubProgramFieldEditor = ProgramFieldEditor(undefined);
